import { loadingMixin } from "smck-service";

export default {
  name: "Internal",
  mixins: [loadingMixin],
  data() {
    return {
      delayTime: 0
    };
  },
  mounted() {}
};
